import { render, staticRenderFns } from "./RelatedLinkLogs.vue?vue&type=template&id=2e2390f4&"
import script from "./RelatedLinkLogs.vue?vue&type=script&lang=js&"
export * from "./RelatedLinkLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports